import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const createPermissionsDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.permissionName',
        popover: {
          title: 'Enter Permission Name',
          description:
            'Use this field to specify the name of the permission. Make sure it clearly defines the permission’s role and scope.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.permissionDescription',
        popover: {
          title: 'Add Permission Description',
          description:
            'Provide a detailed description of the permission. This helps users understand what actions or access the permission controls.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.createPermission',
        popover: {
          title: 'Create Permission',
          description:
            'Click this button to finalize and create the permission. Ensure all details are correctly filled before confirming the creation.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.cancelPermissionCreation',
        popover: {
          title: 'Cancel Permission Creation',
          description:
            'Click here to cancel the permission creation process. Any unsaved changes will be lost, and the permission will not be created.',
          side: 'top',
          align: 'end',
        },
      },
    ],
  });
  return driverObj;
};
export default createPermissionsDriverObj;
